<template>
  <div class="flow-chart">
    <div style="height:100%;width:100%;">
      <div :id="`Schedule`" style="height: 100%;z-index:0"></div>
    </div>
  </div>
</template>
<script>
var go = window.go
export default{
  name: 'diagram',
  props: {
    modelData: {},
    swiperIndex: ''
  }, // accept model data as a parameter
  data() {
    return {
      collapsable: false,
      diagram: null,
      myDiagram: null,
      myPalette: null
    }
  }, // provide access to the GoJS Diagram

  mounted: function() {
    this.init()
    this.diagram = this.myDiagram
    this.updateModel(this.modelData)
  },
  watch: {
    modelData: function(val) {
      this.updateModel(val)
    }
  },
  methods: {
    saveDiagramProperties() {
      this.myDiagram.model.modelData.position = go.Point.stringify(this.myDiagram.position)
    },
    init() {
      var self = this
      var $ = go.GraphObject.make // for conciseness in defining templates
      function TopRotatingTool() {
        go.RotatingTool.call(this)
      }
      go.Diagram.inherit(TopRotatingTool, go.RotatingTool)

      /** @override */
      TopRotatingTool.prototype.updateAdornments = function(part) {
        go.RotatingTool.prototype.updateAdornments.call(this, part)
        var adornment = part.findAdornment('Rotating')
        if (adornment !== null) {
          adornment.location = part.rotateObject.getDocumentPoint(new go.Spot(0.5, 0, 0, -30)) // above middle top
        }
      }

      /** @override */
      TopRotatingTool.prototype.rotate = function(newangle) {
        go.RotatingTool.prototype.rotate.call(this, newangle + 90)
      }
      this.myDiagram =
      $(go.Diagram, `Schedule`, // must name or refer to the DIV HTML element
        {
          'toolManager.hoverDelay': 50,
          isReadOnly: true,
          // allowSelect: false,
          autoScale: go.Diagram.Uniform,
          allowHorizontalScroll: false,
          allowVerticalScroll: false,
          initialContentAlignment: go.Spot.Center,
          'animationManager.isEnabled': false,
          'draggingTool.dragsLink': true,
          'draggingTool.isGridSnapEnabled': true,
          'linkingTool.isUnconnectedLinkValid': true,
          'linkingTool.portGravity': 20,
          'relinkingTool.isUnconnectedLinkValid': true,
          'relinkingTool.portGravity': 20,
          'rotatingTool.snapAngleMultiple': 15,
          'rotatingTool.snapAngleEpsilon': 15,
          'undoManager.isEnabled': true,
          'undoManager.handleChanged': function(e) { self.$emit('undo-changed', e) },
          'ModelChanged': function(e) { self.$emit('model-changed', e) },
          'ChangedSelection': function(e) { self.$emit('changed-selection', e) }
        })

      this.myDiagram.nodeTemplate =
      $(go.Node, 'Spot',
        { locationSpot: go.Spot.Center },
        new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
        { selectable: true },
        // { resizable: true, resizeObjectName: 'PANEL', resizeAdornmentTemplate: nodeResizeAdornmentTemplate },
        // { rotatable: true, rotateAdornmentTemplate: nodeRotateAdornmentTemplate },
        // the main object is a Panel that surrounds a TextBlock with a Shape
        $(go.Panel, 'Auto',
          { name: 'PANEL' },
          $(go.Shape, 'RoundedRectangle', // default figure
            {
              desiredSize: new go.Size(80, 80),
              portId: '', // the default port: if no spot on link data, use closest side
              fromLinkable: true,
              toLinkable: true,
              cursor: 'pointer',
              fill: 'white', // default color
              margin: 2,
              strokeWidth: 0
            },
            new go.Binding('figure'),
            new go.Binding('fill')),
          $(go.TextBlock,
            {
              font: '14px bold Source Han Sans CN,Helvetica, Arial, sans-serif',
              margin: 8,
              maxSize: new go.Size(60, NaN),
              wrap: go.TextBlock.WrapFit,
              editable: true,
              stroke: '#fff'
            },
            new go.Binding('text').makeTwoWay())
        )
      )
      this.myDiagram.linkTemplate =
      $(go.Link, // the whole link panel
        { selectable: true },
        { relinkableFrom: true, relinkableTo: true, reshapable: true },
        {
          routing: go.Link.AvoidsNodes,
          curve: go.Link.JumpGap,
          corner: 5,
          adjusting: go.Link.Stretch,
          toShortLength: 4
        },
        new go.Binding('points').makeTwoWay(),
        $(go.Shape, // the link path shape
          {
            isPanelMain: true,
            stroke: '#1a78b4',
            strokeWidth: 3,
            strokeDashArray: []
          },
          new go.Binding('stroke', 'color'),
          new go.Binding('strokeDashArray', 'dash')),
        $(go.Shape, // the arrowhead
          new go.Binding('stroke', 'color'),
          { toArrow: 'Standard', stroke: '#1a78b4', fill: '#1a78b4', strokeWidth: 3 }),
      )
    },
    model() {
      return this.diagram.model
    },
    updateModel(val) {
      // No GoJS transaction permitted when replacing Diagram.model.
      if (val instanceof go.Model) {
        this.diagram.model = val
      } else {
        const m = new go.GraphLinksModel()
        if (val) {
          for (const p in val) {
            if (val[p]) {
              m[p] = val[p]
            }
          }
        }
        this.diagram.model = m
      }
    },
    clearSelection() {
      this.diagram.clearSelection()
    },
    updateDiagramFromData() {
      this.diagram.startTransaction()
      // This is very general but very inefficient.
      // It would be better to modify the diagramData data by calling
      // Model.setDataProperty or Model.addNodeData, et al.
      this.diagram.updateAllRelationshipsFromData()
      this.diagram.updateAllTargetBindings()
      this.diagram.commitTransaction('updated')
    }
  }
}

</script>
<style lang="scss">
.flow-chart{
  width: 100%;
  height: 100%;
}
#myPaletteDiv div{
  overflow: visible !important;
}

</style>
